module.exports = __webpack_public_path__ + "fonts/PRmiXeptR36kaC0GEAetxkWd5At5A4dPjoTcH8-WMxA.woff2";